import React, { useState, createContext } from "react";
import { isNil } from "ramda";
import { ThemeProvider } from "@mui/material/styles";
import getTheme from "./themeSwitcher";

export const CustomThemeContext = createContext({
  currentTheme: "iteam",
  setTheme: null,
});

function CustomThemeProvider({ children }) {
  const currentTheme = localStorage.getItem("appTheme") || "iteam";

  const [themeName, _setThemeName] = useState(currentTheme);

  let theme = getTheme(themeName);

  const setThemeName = (name) => {
    localStorage.setItem("appTheme", name);
    _setThemeName(name);
  };

  const contextValue = {
    currentTheme: themeName,
    setTheme: setThemeName,
  };

  //  fallback in case and unknown theme was used
  if (isNil(theme)) {
    setThemeName("iteam");
  }

  return (
    <CustomThemeContext.Provider value={contextValue}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </CustomThemeContext.Provider>
  );
}

export default CustomThemeProvider;
